import { combineReducers } from 'redux';
import authUser from 'reducers/authUser';

export default combineReducers({
  authUser,
})